var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMDatos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2eccb6;}.cls-2{fill:#329be6;}.cls-3{fill:#0b5c96;}.cls-4{fill:#fff;}.cls-5{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m_datos"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mis_Datos",
    "data-name": "Mis Datos"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.05,49,32.72,65.72a.4.4,0,0,0,.56,0L50,49.05a25.42,25.42,0,0,0-33.9,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54,53.7a.39.39,0,0,0,.54.11l1.34-.88a.39.39,0,0,0,.11-.56,27.74,27.74,0,0,0-4.37-5L50,49.05A25.25,25.25,0,0,1,54,53.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10,52.37a.39.39,0,0,0,.11.56l1.34.88A.39.39,0,0,0,12,53.7,25.64,25.64,0,0,1,16.05,49l-1.7-1.69A27.74,27.74,0,0,0,10,52.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M14.35,47.35,16.05,49a25.42,25.42,0,0,1,33.9,0l1.7-1.7a27.81,27.81,0,0,0-37.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33,12.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.72,32.72,33.28.28a.4.4,0,0,0-.56,0L.28,32.72a.4.4,0,0,0,0,.56L14.35,47.35a27.81,27.81,0,0,1,37.3,0L65.72,33.28A.4.4,0,0,0,65.72,32.72ZM33,35.57A12.93,12.93,0,1,1,45.92,22.65,12.93,12.93,0,0,1,33,35.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33,9.72A12.93,12.93,0,1,0,45.92,22.65,12.94,12.94,0,0,0,33,9.72Zm0,23.45a10.52,10.52,0,0,1-.11-21H33a10.53,10.53,0,0,1,0,21.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M22.48,22.64A10.52,10.52,0,1,0,33,12.12h-.11A10.53,10.53,0,0,0,22.48,22.64Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    width: 66,
    height: 66
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMDatos);
export default __webpack_public_path__ + "static/media/m_datos.cbb98842a33feb85b8f848f25880a02a.svg";
export { ForwardRef as ReactComponent };